import React, { Fragment, useEffect } from "react";
import { connect } from "react-redux";
import { Breadcrumbs, Card, CardContent, Chip, Grid, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { getByAreaDataCommon, getByAreaCheckInDataCommon, getHomePictreeCheckInOverviewCommon, setCurrentPage } from "actions";
import * as C from "components";
import * as V from "styles/variables";
import CalendarRangePicTreeCommon from "components/Calendar/CalendarRangePicTreeCommon";
import ByAreaSummary from "components/PicTree/Game/Area/ByAreaSummary";
import ByAreaDetailTableCommon from "components/PicTree/Game/Area/ByAreaDetailTableCommon";
import ByAreaCheckInSummary from "components/PicTree/Game/Area/ByAreaCheckInSummary";
import ByAreaCheckInDetailTableCommon from "components/PicTree/Game/Area/ByAreaCheckInDetailTableCommon";

const useStyles = makeStyles((theme) => ({
  breadcrumbs: { marginTop: 16, minHeight: 30 },
  gridSection: { marginTop: theme.spacing(1) },
  loaderBox: { width: "100%", minHeight: 280, display: "flex", alignItems: "center", justifyContent: "center" },
  loaderBarImg: { width: 40 },
  noData: { minHeight: 280, display: "flex", alignItems: "center", justifyContent: "center" },
}));

const PicTreePhotoByAreaCommon = ({
  pageTopLoader,
  dateRangePicTreeCommon,
  dataType,
  byAreaDataSummary,
  byAreaDataTable,
  checkInByAreaData,
  homeDataCheckInOverview,
  selectedAreaLayerId,
  setCurrentPage,
  getByAreaDataCommon,
  getByAreaCheckInDataCommon,
  getHomePictreeCheckInOverviewCommon,
}) => {
  const classes = useStyles();
  useEffect(() => {
    setCurrentPage(window.location.pathname);
  }, [setCurrentPage]);

  useEffect(() => {
    if (
      !Array.isArray(dateRangePicTreeCommon) ||
      dateRangePicTreeCommon.length !== 2 ||
      !dateRangePicTreeCommon[0] ||
      !dateRangePicTreeCommon[1]
    ) return;
    const payload = { dateRange: dateRangePicTreeCommon, areaLayerId: selectedAreaLayerId };
    if (dataType === "report") {
      getByAreaDataCommon(payload);
    } else {
      getByAreaCheckInDataCommon(payload);
      getHomePictreeCheckInOverviewCommon({ dateRange: dateRangePicTreeCommon });
    }
  }, [dataType, dateRangePicTreeCommon, selectedAreaLayerId, getByAreaDataCommon, getByAreaCheckInDataCommon, getHomePictreeCheckInOverviewCommon]);

  const hasData = dataType === "report"
    ? Array.isArray(byAreaDataTable) && byAreaDataTable.length > 0
    : Array.isArray(checkInByAreaData?.rows) && checkInByAreaData.rows.length > 0;
  const isCheckInLoading = dataType !== "report" && (
    pageTopLoader ||
    checkInByAreaData?.status === "idle" ||
    checkInByAreaData?.status === "loading"
  );
  const checkInRows = (checkInByAreaData?.rows || []).map((row) => [
    row.index,
    row.areaName,
    ...(selectedAreaLayerId !== "japan_1_l1" ? [row.prefectureName] : []),
    row.registeredAssetCount,
    row.checkinCount,
    row.checkinAssetCount,
    row.achievementRatePercent,
    row.checkinUserCount,
  ]);

  return (
    <Fragment>
      <C.ContentWrapper>
        <Grid
          container
          spacing={0}
          direction="row"
          style={{ marginTop: -16, marginBottom: 8 }}
          justifyContent="space-between"
        >
          <Grid item>
            <Breadcrumbs separator="›" className={classes.breadcrumbs}>
              <Typography>PicTrée 汎用事業者</Typography>
              <Typography>エリア別</Typography>
            </Breadcrumbs>
          </Grid>
          <Grid item>
            <CalendarRangePicTreeCommon mDate="2026/09/01" page="pictree" pictree />
          </Grid>
        </Grid>

        <Grid container spacing={0}>
          <Grid item xs={12}>
            <Card>
              <CardContent>
                {dataType === "report" ? <ByAreaSummary data={byAreaDataSummary} /> : checkInByAreaData?.status === "error" ? <Typography color="error">データの取得に失敗しました</Typography> : <ByAreaCheckInSummary data={checkInByAreaData?.summary} periodUniqueUsers={homeDataCheckInOverview?.uniqueCheckinUserCount} />}
              </CardContent>
            </Card>
          </Grid>
        </Grid>

        <Grid container spacing={1} className={classes.gridSection}>
          <Grid item xs={12}>
            {pageTopLoader || isCheckInLoading ? (
              <div className={classes.loaderBox}>
                <img alt="" className={classes.loaderBarImg} src="/static/images/loader-bar.gif" />
              </div>
            ) : dataType !== "report" && checkInByAreaData?.status === "error" ? (
              <div className={classes.noData}><Chip label="データの取得に失敗しました" style={{ color: V.textColor, backgroundColor: V.placeholderColor }} /></div>
            ) : dataType !== "report" ? (
              hasData ? <ByAreaCheckInDetailTableCommon data={checkInRows} areaLayerId={selectedAreaLayerId} /> : (
              <div className={classes.noData}>
                <Chip label="No Data" style={{ color: V.textColor, backgroundColor: V.placeholderColor }} />
              </div>)
            ) : hasData ? (
              <ByAreaDetailTableCommon data={byAreaDataTable} areaLayerId={selectedAreaLayerId} />
            ) : (
              <div className={classes.noData}>
                <Chip label="No Data" style={{ color: V.textColor, backgroundColor: V.placeholderColor }} />
              </div>
            )}
          </Grid>
        </Grid>
      </C.ContentWrapper>
    </Fragment>
  );
};

const mapStateToProps = (state) => ({
  pageTopLoader: state.page.pageTopLoader,
  dateRangePicTreeCommon: state.page.dateRangePicTreeCommon,
  dataType: state.pictreeCommon.dataType,
  byAreaDataSummary: state.pictreeCommon.byAreaDataSummary,
  byAreaDataTable: state.pictreeCommon.byAreaDataTable,
  checkInByAreaData: state.pictreeCommon.checkInByAreaData,
  homeDataCheckInOverview: state.pictreeCommon.homeDataCheckInOverview,
  selectedAreaLayerId: state.pictreeCommon.selectedAreaLayerId,
});

const mapDispatchToProps = (dispatch) => ({
  setCurrentPage: (param) => dispatch(setCurrentPage(param)),
  getByAreaDataCommon: (param) => dispatch(getByAreaDataCommon(param)),
  getByAreaCheckInDataCommon: (param) => dispatch(getByAreaCheckInDataCommon(param)),
  getHomePictreeCheckInOverviewCommon: (param) => dispatch(getHomePictreeCheckInOverviewCommon(param)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PicTreePhotoByAreaCommon);
